// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3SejZ","container":"styles_container__2n0H7","title":"styles_title__1OE5u","wrapper":"styles_wrapper__28VO6","answer":"styles_answer__1jEYp"};